
export interface UserModelData {
    _id?: number;
    _firstName?: string;
    _lastName?: string;
    _avatarUrl?: string;
}
export class UserModel {
    id?: number;
    firstName?: string;
    lastName?: string;
    avatarUrl?: string;

    public static fromApi(data: UserModelData): UserModel {
        return new UserModel(data);
    }

    constructor({ _id, _firstName, _lastName, _avatarUrl }: UserModelData) {
        this.id = _id;
        this.firstName = _firstName;
        this.lastName = _lastName;
        this.avatarUrl = _avatarUrl;
    }
}
